import React, { Component } from "react";
import 'react-block-ui/style.css';
import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';
import ReportsService from '../utils/ReportsService';

const StatTable = (props) => {
  const { title, data } = props;

  const rows = data.map((value, index) => (
    <tr key={index}>
      <td>{index}</td>
      <td>{value["first_name"]}</td>
      <td>{value["last_name"]}</td>
      <td>{value["email"]}</td>
      <td>{value["monthly_deal_count"]}</td>
      <td>{value["weekly_deal_count"]}</td>
      <td>{value["daily_deal_count"]}</td>
    </tr>
  ));

  return (
    <div style={{
      width: '100%', padding: 20, margin: 10, background: '#fefefe', border: '1px solid #ccc'
    }}>
      <h4 style={{ marginTop: 0 }}>{title}</h4>
      <table className='table table-bordered'>
        <thead>
          <tr>
            <th style={{ width: 100 }}>Index</th>
            <th style={{ width: 100 }}>First Name</th>
            <th style={{ width: 100 }}>Last Name</th>
            <th style={{ width: 100 }}>Email</th>
            <th style={{ width: 100 }}>Monthly TCS Bookings</th>
            <th style={{ width: 100 }}>Weekly TCS Bookings</th>
            <th style={{ width: 100 }}>Daily TCS Bookings</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    </div>
  );
};

class ReportingTCSBookedBySalesPerson extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view
    };
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, () => {
      this.fetchItems()
    })
  }

  fetchItems() {
    this.setState({ loadingInProgress: true });
    ReportsService.bookedTCSBySalesPerson().then(data => {
      this.setState({ loadingInProgress: false, data: data });
    });
  }  

  render() {
    console.log("this.state.data", this.state.data)
    if (!this.state.data) return null

    return (
      <LoadingIndicator loadingInProgress={this.state.loadingInProgress}>
        <StatTable title='TCS Calls booked by Sales Person' data={this.state.data.result}></StatTable>
      </LoadingIndicator>
    );
  }
}
export default ReportingTCSBookedBySalesPerson
